<footer class="container-fluid footer">
  <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
          <app-upcoming></app-upcoming>
      </div>
  </div>
</footer>

<div class="footer-menu">
    <div class="wrapper">
        <div class="button-f" [routerLink]="isLogin() ? ['/dashboard'] : ['/home']" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/home.svg" alt=""></div><span>Home</span></div>
        <div class="button-f" routerLink="/inplay" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/inplay.svg" alt=""></div><span>Inplay</span></div>
        <div class="button-f" [routerLink]="['/casino', 99999]" routerLinkActive="active">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/mini_games.gif" alt=""></div><span>MiniGame</span></div>
        <div class="button-f" (click)="isLogin() ? openRightBar() : openLogin(); ">
            <div class="icon"><img src="https://speedcdn.io/assets/radheexch-client/icons/menu.svg" alt=""></div><span>Menu</span></div>
    </div>
  </div>
  
<!-- Right bar overlay-->
<div class="leftbar-overlay"></div>